import { GRAPH_DEFAULT_NODE_CLASS_NAME, GRAPH_GROUP_NODE_CLASS_NAME } from "Common/componentUtils/constants";
import themeVariables from "../themeVariables";
export const yfilesTemplatesStyles = `
  .yfiles-node-selection-template,
  .yfiles-node-focus-template,
  .yfiles-node-highlight-template {
    stroke-width: 0;
    fill: transparent;
  }
  .yfiles-handle-move-template,
  .yfiles-bend-template {
    display: none;
  }
  .yfiles-edge-focus-template {
    stroke: ${themeVariables["gray-400"]};
  }
  .yfiles-selection-template.yfiles-edge-selection-template,
  .yfiles-edge-highlight-template {
    stroke: transparent;
    stroke-linejoin: miter;
    stroke-miterlimit: 10;
    stroke-width: 3;
    stroke-linecap: round;
  }

  .yfiles-marquee-rect-template {
    fill: ${themeVariables["brand-primary-200"]};
    stroke: ${themeVariables["brand-primary-500"]};
  }

  .yfiles-handle {
    color: ${themeVariables["brand-primary-500"]};
  }

  .yfiles-handle-resize-template {
    fill: ${themeVariables["brand-primary-500"]};
    stroke: ${themeVariables["brand-primary-500"]};
    rx: 3px;
    ry: 3px;
    stroke-opacity: 0.5;
  }

  .yfiles-port-candidate-template.yfiles-valid .yfiles-outer-rect {
    fill: ${themeVariables["brand-primary-500"]};
  }
  .yfiles-port-candidate-template.yfiles-valid .yfiles-inner-rect {
    opacity: 0;
  }
  .yfiles-port-candidate-template.yfiles-valid .yfiles-corner-path {
    stroke: #fff;
  }

  .yfiles-tooltip {
    background-color: #fff;
    padding: 0.5em 1em;
    font-size: ${themeVariables["font-size-base"]};
    color: ${themeVariables["text-color"]};
    border: ${themeVariables["popover-border-width"]} solid ${themeVariables["popover-border"]};
    border-radius: ${themeVariables["border-radius-base"]};
    line-height: ${themeVariables["line-height-base"]};
    box-shadow: ${themeVariables["popover-box-shadow"]};
    white-space: pre-wrap;
  }
`;
export const yfilesBaseStyles = `
  path,
  rect {
    stroke-dasharray: 0;
    stroke-dashoffset: 0;
    transition: filter 1.5s linear;
  }

  foreignObject {
    overflow: visible;
  }
`;
export const yfilesSelectedNodeStyles = `
  > rect.${GRAPH_DEFAULT_NODE_CLASS_NAME} {
    filter: drop-shadow(4px 2px 4px rgba(100, 100, 100, 0.4));
  }
`;
export const yfilesHighlightedStyles = `
  > rect.${GRAPH_GROUP_NODE_CLASS_NAME}, > rect.${GRAPH_DEFAULT_NODE_CLASS_NAME} {
    filter: drop-shadow(0px 2px 15px rgba(255, 180, 31, 1));
  }
`;
